<template>
  <modal
    name="tempdata-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto"
  >
    <div
      class="v--modal-close-top"
      v-loading.fullscreen.lock="fullscreenLoading"
    >
      <el-button
        @click="closeDialog"
        icon="el-icon-circle-close"
        style="font-size: 2rem"
        type="text"
      ></el-button>
    </div>
    <div
      style="display: inline-block; min-width: 100%; text-align: center"
      v-if="dispSaveform && !dispLoadform"
    >
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 140%">
          <img
            src="/static/renew_img/member_regist_main20220708_001.png"
            style="width: 100%"
          />
        </p>
      </div>
      <div style="padding: 20px 0; font-size: 70%">
        Yagishの<router-link
          id="footer-link-terms"
          :to="{ name: 'termsPage' }"
          target="_blank"
          >利用規約</router-link
        >、<router-link
          id="footer-link-terms"
          :to="{ name: 'policyPage' }"
          target="_blank"
          >個人情報の取り扱い</router-link
        >について<br />
        に同意の上、ログインしてください。
      </div>
      <div class="text-center">
        <login-forms />
      </div>
    </div>
    <div
      style="display: inline-block; min-width: 100%; text-align: center"
      v-else-if="!dispSaveform && dispLoadform"
    >
      <p style="font-size: 120%">一時保存したデータがありますか？</p>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: left">
        <p style="font-size: 120%">
          入力中のデータは上書きされます。<br />復旧コードを入力してください
        </p>
      </div>
      <br />
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 140%">
          復旧コード：<br /><el-input
            class="input-md"
            placeholder=""
            title="復旧コード"
            ref="confirmCode"
            v-model="confirmCode"
            type="text"
          ></el-input>
        </p>
      </div>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 140%">
          メールアドレス：<br />
          <el-input
            class="input-md"
            placeholder=""
            title="メールアドレス"
            ref="email"
            v-model="email"
            type="email"
          ></el-input>
        </p>
      </div>
      <br />
      <br />
      <div class="text-center">
        <button
          type="button"
          class="el-button el-button--success"
          id="save-tempdata"
          style="background-color: #0f9934; border-color: #0f9934"
          @click="$eventHub.$emit('load-tempdata')"
        >
          <span>一時データを復元する</span>
        </button>
      </div>
      <br />
      <br />
      <div class="text-center">
        <login-forms />
      </div>
    </div>
    <div
      style="display: inline-block; min-width: 100%; text-align: center"
      v-else
    >
      <p style="font-size: 120%">入力したデータを保存しました。</p>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: left">
        <p style="font-size: 120%">下記のコードでデータを復元できます。</p>
      </div>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: left">
        <p style="font-size: 100%; color: red">
          ※忘れずに保管してください。他人に知られることのないよう、復旧コードの管理は自己責任でお願いします。
        </p>
      </div>
      <br />
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 140%">
          復旧コード：{{ confirmCode }}　<i
            class="el-icon-document"
            @click="copyToClipboard(confirmCode)"
            style="cursor: pointer"
          ></i>
        </p>
      </div>
      <br />
      <div style="display: inline-block; min-width: 100%; text-align: center">
        <p style="font-size: 120%">会員登録しても入力データは保存できます。</p>
      </div>
      <br />
      <div class="text-center">
        <login-forms />
      </div>
      <br />
    </div>
  </modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import _ from '@/assets/lib/my-lodash'
import LoginForms from '@/components/LoginSpecialForms'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      isAgree: false,
      email: '',
      dispSaveform: true,
      dispLoadform: false,
      confirmCode: ''
    }
  },
  created: function () {
    const app = this
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    }
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message({
            message: '復旧コードをコピーしました。',
            type: 'info'
          })
        })
        .catch((e) => {
          console.error(e)
        })
    },
    openDialog: function (id, flag) {
      const app = this
      this.$iterateStorage(
        function (value, key, iterationNumber) {
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
            app.email = value.email
          }
        },
        function (err) {
          if (!err) {
            console.log('Iteration has completed')
          }
        }
      )
      this.formatid = id
      // this.previewHtml = html.$el.innerHTML
      this.$modal.show('tempdata-dialog')
      this.clearLocalStorageConfirmVisible = false
      if (flag == 'save') {
        this.dispSaveform = true
        this.dispLoadform = false
      } else if (flag == 'load') {
        this.dispSaveform = false
        this.dispLoadform = true
      } else {
        this.dispSaveform = true
        this.dispLoadform = false
      }
    },
    closeDialog: function () {
      this.$modal.hide('tempdata-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    saveTempData: async function () {
      const app = this
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message:
            '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      if (app.email == '') {
        this.$message({
          message: 'メールアドレスを入力してください',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const BACKUP_KEYS_LIST = [
        'format_rirekisho',
        'format_shokumukeirekisho',
        'basicData',
        'recentEdit'
      ]
      const storageData = {}
      await this.$iterateStorage(
        function (value, key, iterationNumber) {
          if (_.includes(BACKUP_KEYS_LIST, key)) {
            storageData[key] = value
          }
        },
        function (err) {
          if (err) {
            console.error(err)
          }
        }
      )
      console.error(storageData)
      const formData = new FormData()
      formData.append('email', app.email)
      formData.append('storage_data', JSON.stringify(storageData))
      this.$axios
        .post(this.$varuna.endPoints.tempSave, formData, { timeout: 60000 })
        .then(function (response) {
          app.dispSaveform = false
          app.confirmCode = response.data.confirm_code
          console.log(response.data.confirm_code)
          app.$message({
            message: '一時保存成功しました',
            type: 'success'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '一時保存失敗しました',
            type: 'error'
          })
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    },
    loadTempData: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message:
            '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      const app = this
      if (app.confirmCode == '') {
        this.$message({
          message: '復旧コードを入力してください',
          type: 'error'
        })
        return
      }
      if (app.email == '') {
        this.$message({
          message: 'メールアドレスを入力してください',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      app.$axios
        .get(this.$varuna.endPoints.tempLoad, {
          params: {
            tk: app.confirmCode,
            email: app.email
          }
        })
        .then(function (response) {
          app.fullscreenLoading = false
          app.$cookies.config(0, '')
          app.$cookies.set(
            '_TEMPDATA_CONFIRM_CODE',
            app.confirmCode,
            null,
            null,
            'yagish.jp'
          )
          const BACKUP_KEYS_LIST = [
            'format_rirekisho',
            'format_shokumukeirekisho',
            'basicData',
            'recentEdit'
          ]
          const errors = []
          const data = JSON.parse(response.data.data)
          _.forEach(BACKUP_KEYS_LIST, function (key) {
            if (data.hasOwnProperty(key)) {
              const dataForLocal = data[key]
              app.$setItem(key, dataForLocal, function (err) {
                if (err) {
                  errors.push(err)
                  return
                }
                // console.log('backup-loaded:', key, dataForLocal)
                app.$eventHub.$emit('backup-loaded-' + key, dataForLocal)
              })
            }
          })
          if (errors.length === 0) {
            app.$message({
              message: '一時データを復旧しました',
              type: 'success'
            })
            app.closeDialog()
          }
        })
        .catch(function (error) {
          app.$message({
            message: '復旧を失敗しました。復旧コードをご確認ください',
            type: 'error'
          })
        })
        .finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('save-tempdata', this.saveTempData)
    this.$eventHub.$on('load-tempdata', this.loadTempData)
    this.$eventHub.$on('open-tempdata-dialog', this.openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('save-tempdata', this.saveTempData)
    this.$eventHub.$off('load-tempdata', this.loadTempData)
    this.$eventHub.$off('open-tempdata-dialog', this.openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
